import { combineReducers } from 'redux';

// reducers
import currencyReducer from './currency';
import localeReducer from './locale';
import mobileMenuReducer from './mobile-menu';
import sidebarReducer from './sidebar';
import corteReducer from './corte'
import userReducer from './user'
import appReducer from './app';
import graduacionReducer from './graduacion';
import contactologiaReducer from './contactologia';
import errorReducer from './errorHandler';
import clienteDialogReducer from './cliente';
import dialogReducer from './dialog';
import dialogReciboReducer from './dialogRecibo';
import smsReducer from './sms';
import itemDialogReducer from './item'
import itemProviderReducer from './itemProvider'
import billDialogReducer from './bill'
import billNotifyDialogReducer from './billNotify'
import editDialogReducer from './editDialog';
import appointmentDialogReducer from './appointment';
import loginDialogReducer from './login';

import inPutProductDialogReducer from './inPutProduct';
import purchaseDialogReducer from './inPutProductPurchase';
import outPutProductDialogReducer from './outPutProduct';
import areaProductDialogReducer from './areaProduct';
import billPaymentReducer from './bill/billPaymentReducer';
import scleralDialogReducer from './scleral/scleralDialogReducer';
import scleralsClientDialogReducer from './scleralsClient/scleralsClientReducer';

export default combineReducers({
    currency: currencyReducer,
    locale: localeReducer,
    mobileMenu: mobileMenuReducer,
    sidebar: sidebarReducer,
    cortes: corteReducer,
    user: userReducer,
    appInfo: appReducer,
    error: errorReducer,
    graduacion: graduacionReducer,
    contactologia: contactologiaReducer,
    clienteDialog: clienteDialogReducer,
    dialog: dialogReducer,
    dialogRecibo: dialogReciboReducer,
    sms: smsReducer,
    itemDialog: itemDialogReducer,
    itemProvider: itemProviderReducer,
    billDialog: billDialogReducer,
    billNotifyDialog: billNotifyDialogReducer,
    editDialog: editDialogReducer,
    appointmentDialog: appointmentDialogReducer,
    loginDialog: loginDialogReducer,
    inPutProductDialog : inPutProductDialogReducer,
    outPutProductDialog : outPutProductDialogReducer, 
    purchaseDialog : purchaseDialogReducer,
    areaProductDialog : areaProductDialogReducer,
    billPayment : billPaymentReducer,
    scleral: scleralDialogReducer,
    scleralClient: scleralsClientDialogReducer
});